import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  user-select: none;
  flex-wrap: wrap;

  /* Mobile First - 320px+ */
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 12px;
    justify-content: center;
  }

  /* Tablet - 768px+ */
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 12px;
  }

  /* Desktop - 1280px+ */
  @media (min-width: 1280px) {
    gap: 16px;
  }

  /* Large Desktop - 1536px+ */
  @media (min-width: 1536px) {
    gap: 20px;
  }
`;

export const PaginationInfo = styled.div`
  font-size: 10px;
  line-height: 1.4;
  font-weight: 400;
  color: #000000d9;
  white-space: nowrap;
  text-align: center;

  /* Mobile - 480px+ */
  @media (min-width: 480px) {
    font-size: 11px;
    line-height: 1.5;
  }

  /* Tablet - 768px+ */
  @media (min-width: 768px) {
    font-size: 12px;
    text-align: left;
  }

  /* Desktop - 1280px+ */
  @media (min-width: 1280px) {
    font-size: 13px;
  }

  /* Large Desktop - 1536px+ */
  @media (min-width: 1536px) {
    font-size: 14px;
  }
`;

export const PaginationActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;

  /* Mobile - 480px+ */
  @media (min-width: 480px) {
    gap: 6px;
  }

  /* Tablet - 768px+ */
  @media (min-width: 768px) {
    gap: 6px;
    justify-content: flex-end;
  }

  /* Desktop - 1280px+ */
  @media (min-width: 1280px) {
    gap: 8px;
  }

  /* Large Desktop - 1536px+ */
  @media (min-width: 1536px) {
    gap: 10px;
  }
`;

export const PageButton = styled.button`
  width: 32px;
  height: 32px;
  padding: 0 2px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  transition: all 0.2s;

  &:hover:not(.active):not(.ellipsis) {
    border-color: #ed7836;
    color: #ed7836;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(237, 120, 54, 0.2);
  }

  &.active {
    border-color: #ed7836;
    background-color: #ed7836;
    color: white;
    box-shadow: 0 2px 4px rgba(237, 120, 54, 0.3);
  }

  &.ellipsis {
    border: none;
    background: transparent;
    cursor: default;

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`;

export const PageIcon = styled.button`
  width: 32px;
  height: 32px;
  padding: 0 2px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  transition: all 0.2s;

  &:not(:disabled):hover {
    border-color: #ed7836;
    color: #ed7836;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(237, 120, 54, 0.2);
  }

  &:not(:disabled):active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(237, 120, 54, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    background-color: #f5f5f5;
    color: #bfbfbf;
  }

  /* Touch devices */
  @media (hover: none) and (pointer: coarse) {
    width: 32px;
    height: 32px;
    font-size: 12px;

    &:not(:disabled):hover {
      transform: none;
      box-shadow: none;
    }
  }
`;
